// UUID regex pattern to match and remove UUIDs from paths
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Extracts a meaningful view page name from a pathname by removing
 * org slug, workspace ID, UUIDs, and other non-meaningful segments.
 *
 * Examples:
 *   /acme/18d0bf01-.../hub/bdeda824-... -> 'hub'
 *   /acme/18d0bf01-.../hub/datasets/.../edit/latest -> 'hub-datasets-edit'
 *   /acme/18d0bf01-.../catalog/dataobjects/545207d7-... -> 'catalog-dataobjects'
 *   /acme/18d0bf01-.../catalog -> 'catalog'
 */
export function getViewPage(pathname: string): string {
  // Split pathname into segments, filter out empty strings
  const segments = pathname.split('/').filter(Boolean);

  // Remove org slug (first segment) and workspace ID (second segment, which is a UUID)
  // Then filter out any remaining UUIDs and 'latest'
  const meaningfulSegments = segments
    .slice(2) // Skip org slug and workspace ID
    .filter((segment) => !UUID_REGEX.test(segment) && segment !== 'latest');

  return meaningfulSegments.join('-') || 'home';
}
